

export const CHRISTMAS_FEES_ENABLED = true;

export const SPECIAL_NOTICE_ENABLED = false;
